"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clearBlock_1 = require("./clearBlock");
function clearBlocks(blocks) {
    return (blocks || []).map(block => {
        if (block.locked) {
            return Object.assign({}, block);
        }
        return clearBlock_1.clearBlock(block);
    });
}
exports.clearBlocks = clearBlocks;
// Old code:
// import { EmailTemplateBlock } from '@osmosys/models';
// export const clearBlocks = (
//   blocks: EmailTemplateBlock[]
// ): EmailTemplateBlock[] => {
//   if (!blocks) {
//     return [];
//   }
//   return blocks.map(b => {
//     if (b.lockable && b.locked) {
//       return { ...b };
//     }
//     return {
//       ...b,
//       childBlocks: clearBlocks(b.childBlocks || []),
//       contentFeed: null,
//       contentFieldKey: null,
//       contentItem: null,
//       contentSlotNumber: null,
//       contentStr: '',
//     };
//   });
// };
//# sourceMappingURL=clearBlocks.js.map